/**
 * Handle time slot kind
 */
export enum TimeSlotKind {
  UNKNOWN = -1,
  TIMESLOT_1 = 0,
  TIMESLOT_24 = 1,
  TIMESLOT_MAC2 = 2,
}
